import React from "react";
import { Row, Col } from "react-bootstrap";

function HomePageCards({ cardName, description, handleClick }) {
	return (
			<Col xs={2} className={cardName} onClick={() => handleClick()}>
				<Row>
					<Col className={`${cardName}-logo`}></Col>
				</Row>
				<Row>
					<Col className='homepage-cards-description'>
						<p>{description}</p>
					</Col>
				</Row>
				<Row>
					<Col className='homepage-cards-link' >
            {cardName.replaceAll('-', ' ').toUpperCase()}
          </Col>
				</Row>
			</Col>
	);
}

export default HomePageCards;
